export default __webpack_public_path__ + "assets/favicon/R_favicon_active.3f913abf.ico";